<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "assessment",
  data(){
    return {
      dataList:[],
      options:{
        current:1,
        total:0,
        pageSize:10,
        totalPage:1
      },
      name:'',
      bool:false
    }
  },
  methods:{
    list(pageNumber,pageSize){
      const options=this.options;
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.assessmentList, {
        studentId:sessionStorage.getItem("myStudentStudentId"),
        pageNumber:pageNumber||this.options.current,
        pageSize:pageSize||this.options.pageSize,
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let options = this.options;
          options.total= res.data.data.page.count;
          this.dataList = res.data.data.list;
          this.options = options
        }else{

        }
      })
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
  table{
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  tbody{
    width: 100%;
  }
  tr{
    width: 100%;
    line-height: 40px;
    border-radius: 5px;
    border-bottom: 1px solid #ECECEC;
  }
  th{
    font-size: 16px !important;
    background: rgba(61, 144, 246, 0.1);
  }
  td,th{
    text-align: center;
    font-size: 14px;
    span{
      color: #1EA1EE;
      cursor: pointer
    }
  }
}
  .assessment{
    min-height: 500px;
    .list{
      background: #fff;
      min-height: 500px;
      padding: 0 20px 40px;
      &>div>div{
        width: 100%;
      }
      .activeShow{
        cursor: pointer;
        color:#3d90f6;
        margin-right: 30px;
      }
      .getActive{
        cursor: pointer;
      }
      .addTarget{
        overflow: hidden;
        padding: 0;
        width: 940px;
        margin: 0 auto;
        padding-bottom: 20px;
        div{
          float: right;
          width: 150px;
          height: 32px;
          background: linear-gradient(305deg, #3d90f6 0%, #2CB2FF 100%, #2CB2FF 100%);
          border-radius: 2px;
          line-height: 32px;
          font-size: 16px;
          color:#fff;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .add{
      background: #fff;
      min-height: 500px;
      padding: 0 20px 40px;
      .title{
        height: 33px;
        font-size: 24px;
        font-weight: 500;
        color: #5C5C5C;
        line-height: 33px;
      }
      table {
        border-collapse: collapse;
        text-align: center;
        width: 100%;
        th {
          background: rgba(61, 144, 246, 0.2);
        }
        margin: 10px auto 40px;
      }
      tr {
        width: 100%;
      }
      th, td {
        border: 1px solid #C8E6F7;
        height: 40px;
      }
      td {
        font-size: 14px;
        td:first-child{
          background: #FAFDFF;
        }
        input {
          border: none;
          text-align: center;
        }
        width: 16%;
      }
      textarea{
        height: 128px;

      }
      textarea:disabled{
        background: #F0F9FE;
      }
      td:nth-of-type(1){
        background: #FAFDFF;
        width: 20%;
      }
    }
    .buttons{
      width: 200px;
      margin: 30px auto;
      display: flex;
      justify-content: center;
    }
    .show{
      background: #fff;
      min-height: 500px;
      padding: 0 20px 40px;
      .head {
        text-align: center;
        position: relative;
        margin-bottom: 60px;
        p {
          position: absolute;
          text-align: center;
          font-size: 24px;
          color: #3d90f6;
          line-height: 116px;
          width: 100%;
          left: 0;
          top: 26px;
        }
      }
      table {
        border-collapse: collapse;
        text-align: center;
        width: 940px;
        margin: 30px auto 50px;
        th {
          background: #F0F9FE;
        }
        td {
          &:first-child{
            background: #F0F9FE;
          }
        }
      }
      tr {
        width: 100%;
      }
      th {
        width: 150px;
      }
      th, td {
        border: 1px solid #C8E6F7;
        height: 40px;
      }
      td:first-child{
        background: #FAFDFF !important;
      }
      td {
        input {
          border: none;
          width: 100%;
          text-align: center;
        }
        font-size: 14px;
      }
      textarea{
        min-height: 140px;
      }
      textarea:disabled{
        background: #F0F9FE;
        border:none;
        color:#666;
      }
    }

  }
</style>